import { Business } from "@app/models/backend";

export class LeadStateModel {
    leads!: {};
    activePage!: number;
    filterResult!: {}
}